<div
  class="app-container h-100"
  [class.slider-sidenav]="isSliderSidenav"
  [class.open]="!isSidenavCollapsed"
>
  <div class="bg-overlay"></div>
  <div class="layout">
    <!-- header nav -->
    <div
      class="header border-bottom d-flex flex-column"
      [class.extended-header]="eligCompleteService.isEditorActive"
    >
      <div *ngIf="eligCompleteService.isEditorActive" class="edito-top-bar">
        <div></div>
        <span class="d-flex justify-content-center align-items-center h-100"
          >Eligibility Complete Editor</span
        >
        <div class="d-flex flex-row justify-content-end align-items-center h-100 gap-2">
          <button
            class="editor-top-bar-button"
            dxc-button
            (click)="onReviewCompleteRequest()"
            [disabled]="router.url.includes('/eligibility-complete')"
          >
            Review Request
          </button>
          <button
            class="editor-top-bar-button"
            dxc-button
            (click)="eligCompleteService.closeEditor()"
          >
            Close Editor
          </button>
        </div>
      </div>
      <div
        class="d-flex align-items-center h-100 pe-2 pe-md-4 pt-1"
        [class.extended-main-header]="eligCompleteService.isEditorActive"
      >
        <dxc-icon
          dxcIcon="bars"
          dxcSize="xl"
          class="cursor-pointer sidebar-trigger"
          (click)="toggleSidenav($event)"
        />

        <img alt="DentalXChange Logo" class="header-logo" src="assets/images/logo.png" />

        <div class="d-flex align-items-center ms-auto">
          <ng-container
            [ngTemplateOutlet]="dentalLocationDropdown"
            [ngTemplateOutletContext]="{ class: 'd-none d-md-block d-print-block' }"
          />
          <button
            class="ms-2 d-none d-md-block d-print-none"
            [disabled]="!isRealTime"
            dxc-button
            (click)="onNewEligibilityCheck()"
          >
            NEW ELIGIBILITY CHECK
          </button>
          <button
            class="mx-2 d-flex align-items-center justify-content-center d-md-none rounded-circle d-print-none"
            style="width: 3rem; height: 3rem"
            dxc-button
            (click)="eligibilityModalVisible = true"
          >
            <dxc-icon dxcIcon="plus" dxcSize="xl" class="d-print-none" />
          </button>
        </div>
      </div>
    </div>

    <div
      class="content-container"
      [class.content-in-editor-mode]="eligCompleteService.isEditorActive"
    >
      <dxc-side-nav
        class="d-print-none"
        [dxcCollapsedWidth]="sideNavCollapsedWidth"
        [dxcWidth]="240"
        [dxcFooterAction]="footer"
        dxcHeaderRouterLink="eligibility/daily-huddle"
        [dxcHeaderTitle]="
          userData?.user_profile?.firstName || userData?.user_profile?.lastName || ''
        "
        dxcHeaderSubTitle="Front Office User"
        [dxcMenu]="menu"
        [dxcCollapsed]="isSidenavCollapsed && !isSliderSidenav"
        (dxcOnClickOutside)="handleSidenavClickOutside()"
        [dxcDisableAnimation]="isSliderSidenav"
        [dxcHeaderExtra]="isSliderSidenav ? dentalLocationDropdown : null"
      >
        <ng-template #menu>
          <ul>
            <li *ngFor="let navItem of navItems">
              <a
                routerLinkActive="active"
                [routerLink]="navItem.route"
                (click)="onNavigation()"
                dxc-tooltip
                [dxcTooltipTitle]="navItem.name"
                dxcPlacement="right"
                [dxcArrow]="false"
                [dxcTooltipVisible]="isSidenavCollapsed"
              >
                <dxc-sidenav-item [dxcIcon]="navItem.icon">
                  {{ navItem.name }}
                </dxc-sidenav-item>
              </a>
            </li>
          </ul>
        </ng-template>
        <ng-template #footer>
          <span
            role="button"
            (click)="showHelpModal()"
            dxc-tooltip
            dxcTooltipTitle="Need help?"
            [dxcArrow]="false"
            [dxcTooltipVisible]="isSidenavCollapsed"
          >
            <h5 dxc-typography class="mb-4" dxcType="primary">
              <ng-container *ngIf="!isSidenavCollapsed">Need help?</ng-container>
              <dxc-icon
                *ngIf="isSidenavCollapsed"
                class="align-middle ms-2"
                [dxcSize]="'lg'"
                dxcIcon="headset"
              ></dxc-icon>
            </h5>
          </span>
          <span
            role="button"
            (click)="logout()"
            dxc-tooltip
            dxcTooltipTitle="Logout"
            [dxcArrow]="false"
            [dxcTooltipVisible]="isSidenavCollapsed"
          >
            <h5 dxc-typography dxcType="primary">
              <ng-container *ngIf="!isSidenavCollapsed"> Logout </ng-container>
              <dxc-icon
                class="align-middle ms-2"
                [dxcSize]="isSidenavCollapsed ? 'lg' : '1x'"
                dxcIcon="logout"
              ></dxc-icon>
            </h5>
          </span>
        </ng-template>
      </dxc-side-nav>
      <div class="router-content p-2 p-md-4 w-100">
        <div *ngIf="isRealTime">
          <router-outlet></router-outlet>
        </div>
        <div
          *ngIf="!isRealTime"
          class="error h-100 bg-white px-2 px-md-4 d-flex-center flex-column"
        >
          <dxc-empty
            [dxcStatus]="'danger'"
            dxcTitle="Uh oh, it looks like you don't have access to Eligibility AI yet."
            class="mx-auto"
          />
          <div class="carousel-container">
            <ngb-carousel [showNavigationArrows]="false" [pauseOnHover]="false">
              <ng-template ngbSlide>
                <div class="slide-container h-100 text-center position-relative">
                  <img
                    class="illustration"
                    src="assets/images/login-slider/benefits-illustration-dark.png"
                  />
                  <img
                    class="illustration-text"
                    src="assets/images/login-slider/benefits-text-dark.png"
                  />
                </div>
              </ng-template>
              <ng-template ngbSlide>
                <div class="slide-container h-100 text-center position-relative">
                  <img
                    class="illustration"
                    src="assets/images/login-slider/calendar-ai-illustration-dark.png"
                  />
                  <img
                    class="illustration-text"
                    src="assets/images/login-slider/calendar-ai-quote-dark.png"
                  />
                </div>
              </ng-template>
              <ng-template ngbSlide>
                <div class="slide-container h-100 text-center position-relative">
                  <img
                    class="illustration"
                    src="assets/images/login-slider/data-illustration-dark.png"
                  />
                  <img
                    class="illustration-text"
                    src="assets/images/login-slider/data-text-dark.png"
                  />
                </div>
              </ng-template>
              <ng-template ngbSlide>
                <div class="slide-container h-100 text-center position-relative">
                  <img
                    class="illustration"
                    src="assets/images/login-slider/phone-calls-illustration-dark.png"
                  />
                  <img
                    class="illustration-text"
                    src="assets/images/login-slider/phone-calls-text-dark.png"
                  />
                </div>
              </ng-template>
            </ngb-carousel>
          </div>
          <button class="my-4 my-xxl-5 d-print-none" dxc-button (click)="navigateToLandingPage()">
            Click here to learn more
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Dental location dropdown -->
  <ng-template #dentalLocationDropdown let-class="class">
    <dxc-dropdown
      class="mx-2 {{ class }}"
      [dxcSelected]="currentLocationId"
      [dxcAllowClear]="false"
      (dxcSelectedChange)="changeDentalLocation($event)"
      [dxcOptions]="dentalLocations"
      >DENTAL LOCATIONS</dxc-dropdown
    >
  </ng-template>
</div>
<app-check-eligibility></app-check-eligibility>
